import React from "react";
import { Avatar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../../../assets/ghostlogo-official.png";

const useStyles = makeStyles((theme) => ({
  logoArea: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    width: 150,
    height: "auto",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "15px",
    },
  },
}));

const Logo = () => {
  const classes = useStyles();
  return (
    <div className={classes.logoArea}>
      <img alt="Ghost Logo" src={logo} className={classes.logo} />
    </div>
  );
};

export default Logo;
